/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ExecuteRecommendationRequest {
    getFixupPrototypeFunction() { return ExecuteRecommendationRequest.fixupPrototype; }

    static newInstance(model: Partial<ExecuteRecommendationRequest>): ExecuteRecommendationRequest {
        let obj = Object.assign(new ExecuteRecommendationRequest(), model);
        ExecuteRecommendationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ExecuteRecommendationRequest>): ExecuteRecommendationRequest {
        if (!model) return null;
        return ExecuteRecommendationRequest.newInstance(<ExecuteRecommendationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ExecuteRecommendationRequest) {
        if (!obj) return;

        models.ExecuteRecommendationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ExecuteRecommendationRequest): boolean {
        Object.setPrototypeOf(obj, ExecuteRecommendationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * action to perform to resolve violations, the name can be obtained from the view recommendation api.  Example: action_name : skip or unskip
     */
    action_name: string;

    /**
     * resource resource_recommendation_id list for which the recommendation will be executed, this value can be obtained from the view recommendation api
     */
    resources: Array<string>;

    /**
     * arguments to execute recommendation if any. The values are dynamic in nature can change from recommendation to recommendation
     */
    args: any;

}
